export const ASSET_TYPE_PATH_SEPARATOR = " > ";

/**
 * Abbreviate an asset-type breadcrumb path for display. When the path has more than four nodes,
 * keep the first two and the last two, with an ellipsis between them — e.g.
 * "Continent > Country > City > Facility > Building > Floor > Room"
 * becomes "Continent > Country > ... > Floor > Room". Shorter paths are returned unchanged.
 *
 * Callers should render the FULL path as a tooltip (e.g. the badge/element `title`).
 */
export function abbreviateAssetTypePath(path: string | undefined | null): string {
  if (!path) {
    return "";
  }
  const segments = path.split(ASSET_TYPE_PATH_SEPARATOR);
  if (segments.length <= 4) {
    return path;
  }
  return [
    segments[0],
    segments[1],
    "...",
    segments[segments.length - 2],
    segments[segments.length - 1],
  ].join(ASSET_TYPE_PATH_SEPARATOR);
}

/**
 * Build the full path string from an ordered list of ancestor nodes (root → leaf).
 */
export function buildAssetTypePath(nodes: { name: string }[]): string {
  return nodes.map((n) => n.name).join(ASSET_TYPE_PATH_SEPARATOR);
}
